module.exports = __webpack_public_path__ + "static/img/bcgtemp.fbe41394.webp";